import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/services/auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Por nombre, no por id: en RoleSeeder el orden es admin, supervisor, user,
 * api, y `adminGuard` ([1,2]) deja pasar a los supervisores de cliente.
 */
export function isSuperadminUser(user: { roles?: Array<{ name?: string }> } | null | undefined): boolean {
  return (user?.roles ?? []).some((role) => role?.name === 'admin');
}

/**
 * Sección Clientes: exclusiva del equipo interno (rol `admin`). El backend
 * rechaza igual con 403 (rutas bajo role:admin); esto evita que un supervisor
 * vea la sección y se coma el error al entrar.
 */
export const superadminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      if (isSuperadminUser(user)) {
        return true;
      }
      router.navigate(['/dashboard/home']);
      return false;
    }),
  );
};
